// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2PwDs","modalForm":"UpgradeEpcsModal_modalForm__3NwK5","modalFooter":"UpgradeEpcsModal_modalFooter__8XzPI"};